import { Button } from "@/components/Button";
import React from "react";

export interface SiteNavLinkProps {
  href: string;
  title: string;
  bold?: boolean;
}

const SiteNavLink = ({ href, title, bold }: SiteNavLinkProps) => (
  <Button
    component="a"
    href={href}
    className={`btn-ghost lg:btn-link -mx-8 block h-auto whitespace-nowrap rounded-none border-0 px-8 py-3 text-left text-base normal-case tracking-normal text-primary lg:mx-0 lg:px-0 lg:py-2 ${
      bold ? "font-semibold" : "font-normal"
    }`}
  >
    <span className="">{title}</span>
  </Button>
);

export default SiteNavLink;
